
import {useReducer} from 'react';


const GenrePanel=({handleGenre,handleAge,handleDropDown})=>
{
    const AgeContentArr={ageList:[{title:'Any Age Group',flag:false},{title:'7+',flag:false},{title:'12+',flag:false},{title:'16+',flag:false},{title:'18+',flag:false}]}
    const initialGenreState={
        genreList:[{title:'All Genre',flag:false},{title:'Education',flag:false},{title:'Sports',flag:false},{title:'Comedy',flag:false},{title:'LifeStyle',flag:false}]
    }

function reducer(state,action){
    //will make switch cases
 switch(action.type){

    case 'ON_SELECT':
        return {...state,...action.payload}
    default:
        return state;
 }
}

function reducer1(state1,action){
    //will make switch cases
 switch(action.type){

    case 'ON_SELECT':
        return {...state1,...action.payload}
    default:
        return state1;
 }
}

const [state,dispatch]=useReducer(reducer,initialGenreState);
const [state1,dispatch1]=useReducer(reducer1,AgeContentArr)

const selectItem=(item,index)=>
{
handleGenre(item.title);
state.genreList[index].flag=!state.genreList[index].flag
dispatch(
    {
        type:'ON_SELECT',
        payload:state.genreList
    }
)
}


const selectAge=(item,index)=>
{
handleAge(item.title);
state1.ageList[index].flag=!state1.ageList[index].flag
dispatch1(
    {
        type:'ON_SELECT',
        payload:state.ageList
    }
)
}

return(
    <>
    <div style={{display:'flex',flexWrap:'wrap',justifyContent:'center'}}>
 
    {state.genreList.map((item,index)=>
    {
        return(
            <div key={index} style={{border:'solid 0.5px',margin:'10px',padding:'5px',borderRadius:'25px',
            backgroundColor:`${item.flag?'white':'grey'}`,cursor: 'pointer'}} 
             onClick={()=>selectItem(item,index)} className='genre-btn'>
            <p style={{margin:'0px'}}>{item.title}</p>
            </div>
        )
    })
    }
     <select name="sort" id="sort" onChange={handleDropDown} className='sort-select'style={{border:'solid 0.5px',margin:'10px',padding:'5px',borderRadius:'25px',
            backgroundColor:'grey',cursor: 'pointer'}}>
        <option value="releaseDate" id="release-date-option" defaultValue> Release Date</option>
        <option value="viewCount" id="view-count-option">View Count</option>
        </select>



     </div>
<div style={{display:'flex',flexWrap:'wrap',justifyContent:'center'}}>
{state1.ageList.map((item,index)=>
    {
        return(
            <div key={index} style={{border:'solid 0.5px',margin:'10px',padding:'5px',borderRadius:'25px',
            backgroundColor:`${item.flag?'white':'grey'}`,cursor: 'pointer'}} 
             onClick={()=>selectAge(item,index)} className='content-rating-btn'>
            <p style={{margin:'0px'}}>{item.title}</p>
            </div>
        )
    })

    }
    </div>
   
    </>
)
}
export default GenrePanel;